import React, { useContext } from "react";
import { Link } from "react-router-dom";
import {
  AlertIndicator,
  alertTypes,
  ModalContext,
} from "@SeemplicityDev/shared";
import "./EnableAIIndicator.scss";

interface EnableAIIndicatorProps {
  info: string;
}

const EnableAIIndicator: React.FC<EnableAIIndicatorProps> = ({ info }) => {
  const { closeModal } = useContext(ModalContext);
  return (
    <AlertIndicator
      type={alertTypes.INFO}
      svgIcon={"icon-ai"}
      content={
        <div>
          {`${info}. Go to`}{" "}
          <Link
            onClick={() => closeModal()}
            to={`/settings/advancedSettings/seemplicityAi`}
            className="link-to-ai-configuration"
          >
            <div className="link-to-ai-configuration">Settings</div>
          </Link>{" "}
          to enable it
        </div>
      }
    />
  );
};

export default EnableAIIndicator;
